/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-utilities';
import type {
  TeachingPopoverCarouselFooterButtonState,
  TeachingPopoverCarouselFooterButtonSlots,
} from './TeachingPopoverCarouselFooterButton.types';

/**
 * Render the final JSX of TeachingPopoverCarouselFooterButton
 */
export const renderTeachingPopoverCarouselFooterButton_unstable = (state: TeachingPopoverCarouselFooterButtonState) => {
  assertSlots<TeachingPopoverCarouselFooterButtonSlots>(state);

  return <state.root />;
};
